<template>
  <div v-if="auth.staff" class="flex lg:gap-2 2xl:gap-4">
    <UiSelect
      v-if="auth.staff.school_classes && auth.staff.school_classes.length > 1"
      v-model="auth.schoolClass"
      :entries="auth.staff.school_classes"
      :labler="({ name }) => `Klasse ${name}`"
      button-class="bg-transparent min-w-[9rem]"
      arrow
    />

    <div class="relative">
      <HeadlessListbox v-model="page">
        <HeadlessListboxButton
          aria-label="change school class dropdown"
          class="
            group size-10 shrink-0 rounded-full bg-violet-500 p-2.5 text-white transition-all
            hover:bg-violet-600
            focus:outline-none
            focus-visible:bg-violet-600 focus-visible:ring-2 focus-visible:ring-focusTeacher
            focus-visible:ring-offset-2
          "
        >
          <IconSetting
            class="
              w-full text-white transition-all will-change-transform
              group-hover:rotate-90
              group-focus-visible:text-focusTeacher
            "
          />
        </HeadlessListboxButton>
        <Transition
          leave-active-class="transition duration-100 ease-in"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <HeadlessListboxOptions
            class="
              style-scrollbar absolute -left-36 z-10 mt-2 w-full min-w-48 rounded-sm bg-surface-300
              ring-offset-4
              before:absolute before:-top-1 before:right-5 before:size-4 before:rotate-45
              before:bg-surface-300
              focus:outline-none
              focus-visible:ring-1 focus-visible:ring-focusTeacher
            "
          >
            <HeadlessListboxOption
              v-for="{ page } in pages"
              :key="page.id"
              v-slot="{ active, selected }"
              :value="page"
              as="template"
            >
              <li
                :class="[
                  active || selected ? 'rounded bg-surface-500' : '',
                  !selected ? 'cursor-pointer' : '',
                  'relative select-none px-3 py-2',
                ]"
              >
                <DynLink
                  :to="page.url"
                  :aria-label="`go to ${page.title}`"
                  class="block truncate text-base"
                >
                  {{ page.title }}
                </DynLink>
              </li>
            </HeadlessListboxOption>

            <li class="relative mt-4 cursor-pointer select-none rounded px-3 py-2 hover:bg-surface-500">
              <button
                aria-label="logout of the platform"
                type="button"
                class="flex flex-col truncate text-left text-base"
                @click="auth.logout()"
              >
                <span class="text-teacher-label md:!text-xs">
                  {{ auth.user?.full_name }}
                </span>
                abmelden
              </button>
            </li>
          </HeadlessListboxOptions>
        </Transition>
      </HeadlessListbox>
    </div>
  </div>
</template>

<script setup lang="ts">
const auth = useAuthStore()
const router = useRouter()
const cms = useCmsStore()

const pages = computed(() =>
  cms.globals?.administration?.tree.filter(({ page }) => {
    return auth.staff?.roles.find(role => page.access.includes(role.name))
  }))

const page = ref(null)

// watch page.value
watch(page, (value) => {
  if (value) {
    router.push(value.url)
  }
})
</script>
